import { render } from "./ModalRates.vue?vue&type=template&id=1721b76b"
import script from "./ModalRates.vue?vue&type=script&lang=js"
export * from "./ModalRates.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__